import { createContext } from "react";

export const ProductsDataBaseContext = createContext(null);